import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, Box, Divider } from '@mui/material'; 
import Loading from '../components/loading';
import api from '../api/api';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import AppointmentStatus from './apointmentsStatus';
import interactionPlugin from "@fullcalendar/interaction";
import { useNavigate } from 'react-router-dom';

function AgendaMobile() {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [appointments, setAppointments] = useState([]);

    const getAppointmentBackground = useCallback((status) => {
        const colors = {
             scheduled: "#0dcaf0ff",
             confirmed: "#0d6efd",
             performed: "#198754",
        };
         if (status === 'SCHEDULED') return colors.scheduled;
         if (status === 'CONFIRMED') return colors.confirmed;
         if (status === 'PERFORMED') return colors.performed;
    }, []);

    const getAppointments = useCallback(() => {
        setLoading(true);
         api.get("/consulta", { 
            headers: { 
                Authorization: sessionStorage.getItem('token') 
            } 
          })
            .then((returnFromApi) => {
                const appointmentConverted = returnFromApi.data.map((appointment) => ({
                     "title": appointment.nomeDoPaciente,
                     "start": appointment.dataEHoraDeInicio,
                     "end": appointment.dataEHoraDeFim,
                     "consultaId": appointment.id,
                     "backgroundColor": getAppointmentBackground(appointment.status)
                }));
                 setAppointments(appointmentConverted);
                 setLoading(false);
             })
             .catch((returnFromApi) => {
                setLoading(false);
                console.error("ops! ocorreu um erro" + returnFromApi);
                if (returnFromApi.status === 401) navigate("/expired-session");
            });
    }, [getAppointmentBackground, navigate]);

    useEffect(() => {
        getAppointments();
    }, [getAppointments]);

    const goToAppointment = (event) => {
        const appointmentId = event?.event?.extendedProps?.consultaId;
        if (appointmentId) {
            navigate('/appointment/'.concat(appointmentId));
        } else {
             const hour = String(event.date.getHours()).padStart(2, '0');
             const minute = String(event.date.getMinutes()).padStart(2, '0');
             const appointmentData = { hour: hour.concat(":").concat(minute), date: event.date };
        
            navigate('/appointment', { state: { appointmentData: appointmentData } });
        }
    }

    return (
        <Box sx={{ p: 2 }}>
            <style>
                {`
                    .fc-toolbar-title {
                        font-size: 1.1rem !important;
                    }

                    .fc-header-toolbar .fc-button {
                        padding: 2px 6px !important;
                        font-size: 0.9rem !important;
                    }
                `}
            </style>

            <Card sx={{ borderRadius: '16px', boxShadow: 'none' }}>
                <CardHeader
                    title="Agenda"
                    titleTypographyProps={{ variant: 'h6', fontWeight: 'bold', color: 'text.secondary' }}
                />
                <Loading isToHidden={isLoading === false} />

                <CardContent> 
                    <AppointmentStatus />
                    <Divider sx={{ my: 2 }} /> 
                    
                    <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        
                        initialView="timeGridDay" 
                        locale="pt-br"
                        
                        contentHeight="75vh" 
                        
                        headerToolbar={{
                            left: 'prev',
                            center: 'title',
                            right: 'next'
                        }}
                        
                        
                        buttonText={{
                            month: 'Mês',
                            day: 'Dia',
                            today: 'Hoje'
                        }}
                        
                        allDayText={"Dia Inteiro"}
                        events={appointments}
                        dateClick={event => goToAppointment(event)}
                        eventClick={event => goToAppointment(event)}
                        
                    />
                </CardContent>
            </Card>
        </Box>
    );
}

export default AgendaMobile;